import CrudCustom from '../../../libs/custom/CrudCustom';

let LogImportService = new CrudCustom('/log-imports');
export default LogImportService;
